import React from 'react'
// import './TexttoSpeech.module.css'
import TextToSpeechHeroSection from './TextToSpeechHeroSection'
import TryItLive from './TryItLive'
import AdvancedCapabilities from './AdvancedCapabilities'
import LanguagesAndUseCases from './LanguagesAndUseCases'
import SimpleApiIntegration from './SimpleApiIntegration'
import PricingSection from './PricingSection'


function TexttoSpeech() {
    return (
        <div>
            <TextToSpeechHeroSection />
            <TryItLive />
            <AdvancedCapabilities />
            <LanguagesAndUseCases />
            <SimpleApiIntegration />
            <PricingSection />
        </div>
    )
}

export default TexttoSpeech
